import {
  Button,
  InputLabel,
  OutlinedInput,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  Grid
} from "@mui/material";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import {useState} from "react";
import {API} from "../framework/api";
import { confirmAlert } from 'react-confirm-alert';
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

export function LoginPage(props) {

  const [values, setValues] = useState({
    username: '',
    password: '',
    showPassword: false,
  });

  const handleChange = (event, prop) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleLogin = () => {
    API.getAPI().auth_login(values.username, values.password).then(()=> {
      window.location.hash="#/anslagstavlan";
    }).catch((e) => {
      confirmAlert({
        title: "Felaktig inloggning",
        message: "Inloggningen misslyckades. Kontrollera dina inloggningsuppgifter och försök igen.",
        buttons: [{
          label: "Avfärda",
          onClick: () => {}
        }]
      });
      console.error(e);
    });
  }

  return (
    <div>
      <div className={"App-title"}>Logga in</div>
      <div className={"App-container App-drop-shadow"}>
        <Grid container={true} spacing={2}>
          <Grid item xs={12} sm={12}>
            <div className={"App-fieldTitle"}>Fyll i ditt användarnamn</div>
          </Grid>
          <Grid item xs={12} sm={12}>

            {/*** Användarnamn ***/}

            <TextField
              fullWidth={1}
              id="outlined-basic"
              label="Användarnamn"
              variant="outlined"
              value={values.username}
              onChange={(e)=> handleChange(e, 'username')}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <div className={"App-fieldTitle"}>Fyll i ditt lösenord</div>
          </Grid>
          <Grid item xs={12} sm={12}>

            {/*** Lösenord ***/}

            <FormControl variant="outlined" fullWidth={1}>
              <InputLabel htmlFor="outlined-adornment-password">Lösenord</InputLabel>
              <OutlinedInput
                fullWidth={1}
                id="outlined-adornment-password"
                type={values.showPassword ? 'text' : 'password'}
                value={values.password}
                onChange={(e) => handleChange(e, 'password')}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {values.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} className={"u-textRight u-marginT20"}>

            {/*** Loginknapp ***/}

            <Button
              className={"App-button-text"}
              variant={"text"}
              onClick={() => { document.location.hash = "#/password-reset"; }}
            >
              Glömt lösenord
            </Button>
            <Button
              className={"App-button-contained"}
              variant={"contained"}
              onClick={handleLogin}
            >
              Logga in
            </Button>
          </Grid>
        </Grid>

      </div>
      <div className={"App-footer"}>
        {/*** Hjälptext och länk till registrering ***/}

        Har du inget konto? Klicka <span className={"u-clickable u-bold"} onClick={() => { document.location.hash = "#/register"; }}>här för att registrera dig</span>.
      </div>
    </div>
  );
}
